import Vue from "vue";
import VueRouter from "vue-router";
import operations from "./operations";
import consult from "./consult";
import caseManage from "./case";
import course from "./course";
import routerUtils from "../libs/routerUtils";
import Login from "../pages/login";
import store from "../store/index";
import meeting from "./meeting";
import user from "./user";
import permission from "./permission";
import error from "./error";
import subject from "./subject";
import templates from "./templates";
import questionnaire from "./questionnaire";
import defaultRoutes from "./defaultRoutes";
import dataManage from "./dataManage";
import { whiteList } from "./whiteList";
import vrManageRoute from "./vrManage";
import Project from "../pages/projects";
import projectManage from "./projectManage";
import documentManage from "./documentManage";
import customizedDataRoute from "./customizedData";
import training from "./training";
import targetManage from "./targetManage";
import examManage from "./examManage";
import workOrderManageRoute from "./workOrderManage";

//  防止重复点击路由
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
Vue.use(VueRouter);

/**
 * 路由字段规则
 * meta:{
 *  title:                  权限控制字段，需要与后台返回的权限相等才能在该项目中加载路由
 *
 *  relatedPermission:      不在后台权限中的路由，但又需要在项目中使用时添加该字段。需要与相关权限的路由title一致,
 *                          histroyRoutes将不会添加有该字段的路由
 *
 *  parentName:             用于在header中展示，需要与相关路由的name保持一致
 * }
 */

//无需权限的路由
export const constantRouterMap = [
  // {
  //   path: "/",
  //   redirect: "/project",
  //   hidden: true,
  // },
  {
    path: "/",
    redirect: "/login",
    hidden: true,
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    hidden: true,
    meta: {
      title: "登录",
    },
  },
  {
    path: "/project",
    name: "project",
    component: Project,
    hidden: true,
    meta: {
      title: "营销云管理后台系统",
    },
  },
  ...user,
  ...error,
  ...defaultRoutes,
];
//需要权限控制的路由
export const asyncRouterMap = [
  ...consult,
  ...course,
  ...questionnaire,
  ...vrManageRoute,
  ...caseManage,
  ...operations,
  ...projectManage,
  ...dataManage,
  ...meeting,
  ...subject,
  ...templates,
  ...training,
  ...targetManage,
  ...documentManage,
  ...customizedDataRoute,
  ...examManage,
  ...permission, //权限需要放到最底部
  ...workOrderManageRoute,
  {
    path: "*", // 此处需特别注意置于最底部
    redirect: "/404",
    hidden: true,
  },
];

const createRouter = () => {
  return new VueRouter({
    routes: constantRouterMap,
    scrollBehavior(to, from, savedPosition) {
      if (savedPosition && to.meta && to.meta.keepAlive) {
        return savedPosition;
      } else {
        return { x: 0, y: 0 };
      }
    },
  });
};
const router = createRouter();

export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

function getDefaultMenu(routes) {
  const indexPath = store.state.common.openeds;
  let res = "";
  if (indexPath !== "/index") {
    const len = indexPath.length;
    const last = len > 1 ? indexPath[len - 1] : indexPath[0];
    res = last;
  }
  const flag = findPath(routes, res);
  return flag ? res : "";
}

function findPath(routes, res) {
  return routes.some((ele) => {
    if (ele.path === res) {
      return true;
    } else {
      if (ele.children && ele.children.length > 0) {
        return findPath(ele.children, res);
      } else {
        return false;
      }
    }
  });
}

function clearStorePath(from) {
  if (from.path === "/questionnaire/manage") {
    store.commit("questionnaire/SET_PAGETYPE", "list");
  }
  if (from.path === "/activity/manage") {
    store.commit("activity/SET_PAGETYPE", "list");
  }
  if (from.path === "/case/list") {
    store.commit("audit/SET_PAGETYPE", "list");
  }
}

router.afterEach(function (to) {
  if (to.path === "/login" || to.path === "/project") {
    store.commit("questionnaire/INIT_QUESTIONNAIRE");
    store.commit("activity/INIT_ACTIVITY");
    store.commit("audit/INIT_AUDIT");

    store.commit("user/SET_INIT_USER"); // 初始化用户
    store.commit("permission/CLEAR_PERMISSION"); //清理权限
    store.commit("common/SET_HISTORY_ROUTER", []); //初始化历史路由
    store.commit("common/SETUP_OPENEDS", "/index"); //初始化选中菜单
  }
  if (to.path === "/login") {
    store.commit("user/SET_INIT_PROJECT"); //清理项目
    store.commit("user/INIT_LOGIN_FORM"); // 初始化登录信息
  }

  if (to.path === "/project") {
    store.commit("user/SET_CURRENT_PROJECT", ""); //初始化当前项目
  }
  // routerUtils.setCurrentPath(to.name);
  routerUtils.setCurrentPath(to);
  routerUtils.setHistoryRoutes(to.path);
});

router.beforeEach((to, from, next) => {
  const MarketingCloudToken = store.state.user.MarketingCloudToken;
  const currentProject = store.state.user.currentProject;
  const projects = store.state.user.projects;

  document.title = (to.meta && to.meta.title) || "营销云管理后台系统";
  // 强制校验未选项目跳转到项目页
  // if (!currentProject && to.path != "/project") {
  //   next("/project");
  // }

  // 强制校验未登录跳转到项目页
  if (!projects.length && !currentProject && to.path != "/login") {
    next("/login");
  }
  // 用户只有一个项目时不让访问项目选择页
  if (
    !(
      projects.length > 1 ||
      (projects.length == 1 && projects[0].sysProjectDTOS.length > 1)
    ) &&
    to.path == "/project"
  ) {
    next("/login");
  }

  if (MarketingCloudToken && currentProject) {
    // 当前项目不存在需要跳转到
    clearStorePath(from);
    if (whiteList.includes(to.path)) {
      next();
    } else {
      if (store.state.permission.menuList.length === 0) {
        //判断是否已经有路由菜单信息
        store
          .dispatch("permission/setMenuList")
          .then((res) => {
            if (res.length === 0) {
              // console.log("404");
              next("/404");
            } else {
              store
                .dispatch("permission/generateRoutes", res)
                .then((routes) => {
                  routes.forEach((r) => {
                    router.addRoute(r);
                  });
                  if (from.path === "/login" || from.path === "/project") {
                    const defaultMenu = getDefaultMenu(routes);
                    if (defaultMenu) {
                      next({ path: defaultMenu, replace: true });
                    } else {
                      const defaultPath =
                        routes[0] &&
                        routes[0].children &&
                        routes[0].children[0] &&
                        routes[0].children[0].path;
                      defaultPath
                        ? next({ path: defaultPath, replace: true })
                        : next(from.path === "login" ? "/login" : "/project");
                    }
                  } else {
                    // 判断三级路由权限
                    const check = routerUtils.checkRoute(from, to);
                    check ? next({ ...to, replace: true }) : next("/404");
                    // next({ ...to, replace: true });
                  }
                });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        // 判断三级路由权限
        const check = routerUtils.checkRoute(from, to);
        check ? next() : next("/404");
      }
    }
  } else {
    const isTrue = to.meta && whiteList.includes(to.path);
    isTrue ? next() : next("/login");
  }
});
export default router;
